export const isNull = (value) => value === null;
export const isNotNull = (value) => value !== null;
export const isPropertyNull = (property) => (value) => value[property] === null;
export const isPropertyNotNull = (property) => (value) => value[property] !== null;
export const arePropertiesNull = (...properties) => (value) => properties.every((property) => value[property] === null);
export const arePropertiesNotNull = (...properties) => (value) => properties.every((property) => value[property] !== null);
